
import RoleList from "./list";


if (document.body.getAttribute("data-current-path") === "settings/roles") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new RoleList();
    }
}